import React from 'react';
import { NavLink } from "react-router-dom";
import Button from '@material-ui/core/Button';
import useStyles from '../styles';

const ProfileTabs = () => {
  const classes = useStyles();
  return (
    <div className={classes.tabsRoot}>
      <div className={classes.tabs}>
        <Button
          component={NavLink}
          to="/profile/account"
          variant="outlined"
          color="primary"
        >
          Account Details
        </Button>
        <Button
          exact
          component={NavLink}
          to="/profile/general"
          variant="outlined"
          color="primary"
        >
          General Info
        </Button>
        <Button
          component={NavLink}
          to="/profile/school"
          variant="outlined"
          color="primary"
        >
          School Info
        </Button>
        <Button
          component={NavLink}
          to="/profile/college"
          variant="outlined"
          color="primary"
        >
          College Info
        </Button>
        <Button
          exact
          component={NavLink}
          to="/profile/payment"
          variant="outlined"
          color="primary"
        >
          Payment
        </Button>
        <Button
          exact
          component={NavLink}
          to="/profile/settings"
          variant="outlined"
          color="primary"
        >
          Notification Settings
        </Button>
      </div>
    </div>
  );
};

export default ProfileTabs;
